<article>
    <div class="px-4">
        <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
            <div class="px-4 py-5 flex-auto">
                <a class="block p-2">
                    <header class="flex items-center">
                        <h4 class="font-mono text-sm md:text-base truncate text-black group-hover:text-indigo-600 dark:group-hover:text-yellow-500 service-card-title">
                            {{serviceItem.name}}
                        </h4>
                        <span *ngIf="serviceItem.status === 'listo'" class="service-deployment-status status-ready"></span>

                        <span *ngIf="serviceItem.status === 'pendiente'" class="service-deployment-status status-pending">{{serviceItem.status}}</span>
                    </header>
                    <div class="flex items-center text-xs md:text-sm text-gray-400 whitespace-nowrap overflow-hidden service-card-category-line">
                        <div class="inline-flex items-center space-x-0.5">
                            <span>{{serviceItem.category}}</span>
                        </div>
                        <span class="px-1.5 text-gray-300 px-2">•</span>
                        <div class="inline-flex items-center space-x-0.5">
                            <app-svg-selector [name]=serviceItem.strTaskType().en></app-svg-selector>
                            <span class="px-2">{{serviceItem.strTaskType().es}}</span>
                        </div>
                    </div>
                    <div class="service-card-description">
                        {{serviceItem.description}}
                    </div>
                </a>
            </div>
        </div>
    </div>
</article>
